import { useSelector } from 'hooks/utils';
import { selectPrimaryPaymentId } from 'store/account/payments';

export function usePrimaryPaymentId() {
	return useSelector(state => selectPrimaryPaymentId(state.account.payments));
}
